import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
//import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5d: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone?`}
        />
        <strong>
          Personal Reflection: How do you feel when using this component when trying to assist someone?
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this.'
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={6}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="4. Don’t promise to keep secrets" />
              <h2 className="txt-green no-bold no-margin">
                4. Don’t promise to keep secrets
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="Safety trumps privacy. There are certain situations in which you will not be able to keep information confidential. When supporting someone with thoughts of suicide or intentions to harm themselves or others, it is important that you involve someone else who is in a position to help intervene. Since you can’t guarantee secrecy, offer instead to treat what they share with you with sensitivity and discretion. This is most often what people are seeking when they ask about secrecy or privacy." />
              <p>
                Safety trumps privacy. There are certain situations where you
                will not be able to keep information confidential. When
                supporting someone with thoughts of suicide or intentions to
                harm themselves or others, it is important that you involve
                someone else who is in a position to intervene. Since you
                can’t guarantee secrecy, offer instead to treat what they share
                with you with <strong>sensitivity and discretion</strong>. This is most often
                what people are seeking when they ask about secrecy or privacy.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_G}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistF = connect.role(AssistPage);

export default AssistF;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistF/index.jsx